import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const GDIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="GD" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#C51918"
        fillRule="evenodd"
        d="M0 0h16v11a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#FECA00"
        fillRule="evenodd"
        d="M3 3h10v6H3V3Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={10}
        height={6}
        x={3}
        y={3}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M3 3h10v6H3V3Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#23875F"
          fillRule="evenodd"
          d="m3 3 5 3-5 3V3ZM13 3 8 6l5 3V3Z"
          clipRule="evenodd"
        />
        <Mask
          id="c"
          width={5}
          height={6}
          x={8}
          y={3}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: "luminance",
          }}
        >
          <Path
            fill="#fff"
            fillRule="evenodd"
            d="M13 3 8 6l5 3V3Z"
            clipRule="evenodd"
          />
        </Mask>
        <Path
          fill="#C51918"
          fillRule="evenodd"
          d="M8 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
          clipRule="evenodd"
        />
        <Path
          fill="#FECA00"
          fillRule="evenodd"
          d="m7.965 6.657-1.036.718.331-1.23-.76-.786 1.03-.042.435-1.217.435 1.217h1.028l-.759.828.38 1.157-1.084-.645Z"
          clipRule="evenodd"
        />
      </G>
      <Path
        fill="#FECA00"
        d="M5.191 10.078h.562l-.414.404.208.566-.593-.316-.566.352.18-.602-.415-.383.563-.02.238-.596.237.595Zm3 0h.562l-.414.404.208.566-.593-.316-.566.352.18-.602-.415-.383.563-.02.238-.596.237.595Zm3 0h.562l-.414.404.208.566-.593-.316-.566.352.18-.602-.415-.383.563-.02.238-.596.237.595ZM5.192 1.216h.562l-.414.404.207.566-.593-.316-.565.35.18-.6-.415-.384.563-.02.237-.595.238.595Zm3 0h.562l-.415.404.208.566-.593-.316-.565.35.18-.6-.416-.384.563-.02.238-.595.238.595Zm3 0h.562l-.415.404.208.566-.593-.316-.565.35.18-.6-.416-.384.563-.02.238-.595.238.595Z"
      />
      <Path
        fill="#C51918"
        fillRule="evenodd"
        d="M4.317 6.386s.27.24.416.322c.05-.192-.062-.626-.062-.626-.032-.104-.379-.29-.379-.29s-.097.327.025.594Z"
        clipRule="evenodd"
      />
      <Path
        fill="#FECA00"
        fillRule="evenodd"
        d="M4.598 6.965s-.692-.323-.762-.78C3.766 5.728 3.915 5 3.915 5s1.123.256 1.2.803c.076.548-.178.892-.178.892s-.26-.668-.505-.742c0 0 0 .662.166 1.012Z"
        clipRule="evenodd"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
